import "@/App.css";
import "@/styles/taandem.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { ContentProvider } from "@/context/ContentContext";
import Landing from "@/pages/Landing";
import CaseDetail from "@/pages/CaseDetail";
import Legal from "@/pages/Legal";

function App() {
  return (
    <div className="App dark">
      <ContentProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/casos/:id" element={<CaseDetail />} />
            <Route path="/aviso-legal" element={<Legal page="aviso-legal" />} />
            <Route path="/privacidad" element={<Legal page="privacidad" />} />
            <Route path="/cookies" element={<Legal page="cookies" />} />
          </Routes>
        </BrowserRouter>
      </ContentProvider>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
